import { defineRecipe } from '@chakra-ui/react';
export const buttonRecipe = defineRecipe({
    base: {
        rounded: 'md',
        fontWeight: 'medium',
        outline: 'none',
    },
    variants: {
        variant: {
            solid: {
                bg: 'colorPalette.solid',
                color: 'colorPalette.contrast',
                _hover: {
                    bg: 'colorPalette.fg',
                },
            },
            subtle: {
                bg: 'colorPalette.subtle',
                color: 'colorPalette.solid',
                _hover: {
                    bg: 'colorPalette.muted',
                    _dark: {
                        bg: 'colorPalette.emphasized',
                    },
                },
                _active: {
                    bg: 'colorPalette.muted',
                    _dark: {
                        bg: 'colorPalette.emphasized',
                    },
                },
            },
            outline: {
                borderWidth: '1px',
                borderColor: 'colorPalette.emphasized',
                color: 'colorPalette.fg',
                _hover: {
                    bg: 'colorPalette.subtle',
                },
            },
            ghost: {
                color: 'colorPalette.fg',
                _hover: {
                    bg: 'colorPalette.subtle',
                },
            },
            // Creator space: the white button beside a call to action.
            secondary: {
                bg: 'panelBg',
                borderWidth: '1px',
                borderColor: 'border',
                color: 'primary.900',
                _hover: {
                    bg: 'softCream',
                    borderColor: 'border.emphasized',
                },
            },
        },
        size: {
            sm: {
                fontSize: 'sm',
            },
            md: {
                fontSize: '15.5px',
            },
            lg: {
                fontSize: 'md',
            },
            // Creator space: the call to action (50px and the 18px radius on a
            // phone, 44px and 12px on a computer).
            cta: {
                h: { base: '50px', md: '44px' },
                minW: '44px',
                px: '18px',
                rounded: { base: 'cta', md: 'lg' },
                fontSize: { base: '15.5px', md: '14px' },
            },
            // Creator space: filter chips and small row buttons. 36px drawn, 44px
            // to touch: the hit area reaches past the pill.
            chip: {
                h: '36px',
                minW: '36px',
                px: '14px',
                rounded: 'full',
                fontSize: '13.5px',
                position: 'relative',
                _before: {
                    content: '""',
                    position: 'absolute',
                    inset: '-4px',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'solid',
        size: 'md',
    },
});
